import React, { Component } from 'react';
import { Trash2 } from 'lucide-react';
import { GeckoIcon, GeckoBtn } from '../../../../components';
import { APP_CONST } from '../../../../constants';
import moment from 'moment';

export class SessionTable extends Component {
    constructor(props) {
        super(props);

        this.renderRows = this.renderRows.bind(this);
    }


    renderRows(data) {
        return data.map((session, key) => {
            return <div key={key}> <ActivityRow SetId={session.SetId} SetName={session.SetName} Client={session.Client} IdToken={session.IdToken} AccessToken={session.AccessToken} RefreshToken={session.RefreshToken} revokeToken={this.props.revoke} /></div>;
        })
    }

    render() {
        return (
            <div className="SessionTable flex flex-col gap-4">
                {this.renderRows(this.props.data)}
            </div>

        )
    }
}

SessionTable.defaultProps = {
    data: [],
}


export const ActivityRow = ({SetId, SetName, Client, IdToken, AccessToken, RefreshToken, revokeToken}) => {
    const isAPIToken = (Client === 'api' ? true : false);

    return (
        <div className="eventRow flex flex-col p-4 border border-border rounded-md gap-4">

            <div className="flex flex-col flex-1 min-w-0">

                <div className="eventType flex flex-row items-center gap-1">
                    <span className="text-sm font-medium text-foreground">{SetName}</span> 
                    {EventResponseBadge(Client)}
                </div>

                { !isAPIToken &&
                    <div className="SessionTable-ActivityRow-tokenMeta text-xs text-muted-foreground">
                        Logged in using a browser
                    </div>
                }
            
                { isAPIToken &&
                    <div className="flex flex-col gap-1 mt-1">
                        <div className="meta flex flex-col gap-1" title="ID token">
                            <span className="text-xs text-foreground font-medium">ID token:</span> 
                            <code className="font-mono text-xs text-red-700 bg-slate-100 px-1.5 py-1.5 rounded border border-border whitespace-nowrap overflow-x-auto block max-w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500">{IdToken}</code>
                        </div>
                        <div className="meta flex flex-col gap-1" title="Access token">
                            <span className="text-xs text-foreground font-medium">Access token:</span> 
                            <code className="font-mono text-xs text-red-700 bg-slate-100 px-1.5 py-1.5 rounded border border-border whitespace-nowrap overflow-x-auto block max-w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500">{AccessToken}</code>
                        </div>
                        <div className="meta flex flex-col gap-1" title="Refresh token">
                            <span className="text-xs text-foreground font-medium">Refresh token:</span> 
                            <code className="font-mono text-xs text-red-700 bg-slate-100 px-1.5 py-1.5 rounded border border-border whitespace-nowrap overflow-x-auto block max-w-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500">{RefreshToken}</code>
                        </div>
                    </div>
                }

            </div>

            <div className="flex">
                <GeckoBtn
                    name="End session"
                    icon={Trash2}
                    type={APP_CONST.BTN_TYPE_OUTLINE}
                    size={APP_CONST.BTN_SIZE_SM}
                    handler={() => revokeToken(SetId)}
                />
            </div>
        </div>
    );
}

export const EventResponseBadge = (value) => {
    if (!value || value === '') {
        return null;
    }

    if (value === 'Fail') {
        return <span className="activityBadge activityFailed text-[10px] font-medium bg-red-50 text-red-700 py-0.5 px-1 rounded-sm">Failed</span>
    }

    return <span className="activityBadge activityFailed text-[10px] font-medium bg-red-50 text-red-700 py-0.5 px-1 rounded-sm">{value}</span>
}

export default SessionTable;